'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = prospectUtks;

var _VisitorActionTypes = require('../constants/VisitorActionTypes');

function prospectUtks() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _VisitorActionTypes.RECEIVED_WIDGET_SHELL_DATA:
      return _extends({}, state, {
        messagesUtk: action.payload.messagesUtk
      });
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/prospectUtks.js
// module id = 1274
// module chunks = 3